import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap  from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import PreviziuniChartData from '../Components/PreviziuniChartData';
import TrendDePastrareClientiTrimestru from '../TrendDePastrareClientiTrimestru';


export default class SegmentareaClientilorStare extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
       bilantData:[],
       prognoza:[],
       topButtons: [{ id: 'clientipierduti', label: 'Clienti pierduti', color: '#900DCB' },
       { id: 'clienticastigati', label: 'Clienti castigati', color: '#C8C779' },
       { id: 'clientiloiali', label: 'Clienti loiali', color: '#59D862' },
       { id: 'clientiactivi', label: 'Clienti Activi', color: 'rgb(215, 89, 216)' },

       ],
        
       mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },
       { id: 'avc', label: 'Analiza de vanzari si client (AVC)', color: '#900DCB' },
       { id: 'analizaclientilornoi', label: 'Analiza clientilor noi, loaiali si pierduti', color: '#900DCB' }
       ]
}
    }

     componentDidMount(){

    }

    goTo = (id) =>{
        this.props.history.push(`/${id}`)
    }

  
     render() { 
       return (
          <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />
             
                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

        <div style={{textAlign:'left'}}>
            {this.state.mapButtons.map((b,idx)=>{
                return(
                    <SiteMap 
                        key={idx}
                        b={b}
                        buttonSelected={this.goTo} />
                        
                )
            })}
        </div>
        <h1 className='pm-title'>Segmentarea clientilor in functie de stare</h1>
        <Grid className='container' style={{ position: 'relative' }} container>
                    {this.state.topButtons.map((b, idx) => {
                        return (
                            <Grid key={idx} style={{ width: 'fit-content', marginTop: 10 }} className="loginButton" item xs={12} sm={12} md={3} lg={3} xl={3} >
                                {/* <Button onClick={this.bilantClick} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBilant}</Button>
                                <Button onClick={this.balantaClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaBalanta}</Button>
                                <Button onClick={this.clientiClick} style={{ width: 'fit-content', marginLeft: 10 }} className='pm-login-button' variant="outlined">{this.dictionary.financiarContabil.importaClienti}</Button>
                            */}


                                <TopButtons
                                    b={b}
                                    buttonSelected={this.goTo}
                                    buttonSelectat={this.state.buttonSelectat}
                                />





                            </Grid>
                        )

                    })}
                </Grid>
           
         </div>
        );
       }
}